const e = "Konto", t = "Kontosaldo", a = "Kontobeskrivning", n = "Konto-id", r = "Tillägg", i = "Justeringar", o = "Belopp", l = "och", s = "Tillämpa", d = "Tillbaka", c = "Saldokonto", g = "ID för saldokonto", u = "Bokad", p = "Insamlad", f = "Kategori", m = "Chargebacks", k = "Stäng", b = "Kontakta supporten", v = "Kontakta support för hjälp.", h = "Kontakta supporten för hjälp och använd felkoden %{requestId}", y = "Kopierat", T = "Kopiera", A = "Rättelser", D = "Valuta", F = "Datum", R = "Datumintervall", P = "Beskrivning", S = "Avvisa", C = "Ladda ner", N = "Nedladdning pågår", O = "E-post", B = "Enheten hittades inte", I = "Transaktionen hittades inte för den angivna kontoinnehavaren", x = "Avgifter", w = "Fil", L = "Filterfält", j = "Från", W = "Full", M = "Insamlade medel", U = "Tillbaka", K = "Beviljat bidrag", E = "Återbetalning av bidrag", q = "Dölj innehåll", V = "ID", H = "Ofullständigt fält", Y = "Pågående", G = "Läser in", _ = "max", z = "min", X = "Mobil", J = "Nettoutbetalning", Q = "Nästa utbetalning", Z = "Inga uppgifter", $ = "Inga negativa tal tillåtna", ee = "Inga utbetalningar hittades", te = "Inga rapporter hittades", ae = "Inga transaktioner hittades", ne = "Annat", re = "Paginerad navigering", ie = "Partiell", oe = "Betalnings-id", le = "Betalningsmetod", se = "Information om utbetalning", de = "Utbetalningsinformation genereras varje dag vid midnatt, UTC-tid.", ce = "Utbetalningar", ge = "Väntande", ue = "Kom tillbaka senare.", pe = "Kontakta supporten för att få hjälp.", fe = "Kontakta supporten", me = "Referens-id", ke = "Uppdatera", be = "Återbetalningar", ve = "Utför återbetalning", he = "Det gick inte att behandla återbetalningen. Försök igen om en stund.", ye = "Något gick fel.", Te = "Kunden får pengarna inom högst 40 dagar. När återbetalningen är klar visas en ny återbetalningstransaktion i listan.", Ae = "Återbetalning skickad!", De = "Belopp att återbetala", Fe = "Återbetalning kan ta upp till 40 dagar beroende på betalningssätt. Avgifter ingår.", Re = "Återbetalning %{amount}", Pe = "Orsak till återbetalning", Se = "Referens", Ce = "Återstående belopp", Ne = "Rapport", Oe = "Rapporter genereras varje dag vid midnatt, UTC-tid.", Be = "Rapporter", Ie = "Återställ", xe = "Upphävt", we = "Något gick fel.", Le = "Något gick fel. Försök att uppdatera sidan eller kom tillbaka senare.", je = "Status", We = "Strukturerad lista", Me = "Subtraktioner", Ue = "Summan av utbetalningar samma dag", Ke = "Flikar", Ee = "Felkoden är %{requestId}", qe = "Det finns inga resultat", Ve = "Begäran saknar obligatoriska fält eller innehåller ogiltiga data.", He = "Det uppstod ett oväntat fel", Ye = "Det valda saldokontot är felaktigt", Ge = "Tidszon", _e = "Till", ze = "Totalt inkommande", Xe = "Totalt utgående", Je = "Till-värdet ska vara lika med eller större än Från-värdet", Qe = "Transaktionsdetaljer", Ze = "Transaktioner", $e = "Transaktionsöversikt", et = "Transaktionstyp", tt = "Överföringar", at = "Försök med en annan sökning eller återställ dina filter, så försöker vi igen.", nt = "Försök att uppdatera sidan eller kom tillbaka senare.", rt = "Belopp", it = "Typ", ot = "Värde", lt = "Det gick inte att läsa in utbetalningsmenyn.", st = "Det gick inte att läsa in rapportöversikten.", dt = "Det gick inte att läsa in transaktionsöversikten.", ct = "Det gick inte att läsa in dina saldokonton.", gt = "Det gick inte att läsa in dina utbetalningar.", ut = "Det gick inte att läsa in dina rapporter.", pt = "Det gick inte att läsa in dina transaktioner.", ft = {
  account: e,
  accountBalance: t,
  accountDescription: a,
  accountID: n,
  additions: r,
  adjustments: i,
  amount: o,
  and: l,
  apply: s,
  back: d,
  balanceAccount: c,
  balanceAccountId: g,
  Booked: u,
  "button.clearAll": "Rensa alla",
  "calendar.controls": "Kontroller för kalendernavigering",
  "calendar.nextMonth": "Nästa månad",
  "calendar.previousMonth": "Föregående månad",
  "calendar.timezone": "Tidszonen är inställd på: GMT%{offset} (%{time})",
  "capital.accountIsInactive": "Ditt konto är inaktivt",
  "capital.actionNeeded": "Åtgärd krävs",
  "capital.bankAccountDetails": "Uppgifter om bankkonto",
  "capital.bankAccountIban": "IBAN",
  "capital.bankAccountNumber": "Kontonummer",
  "capital.bankCountryOrRegion": "Land/region",
  "capital.bankRoutingNumber": "Clearingnummer",
  "capital.bankSortCode": "Clearingnummer",
  "capital.businessFinancing": "Företagsfinansiering",
  "capital.businessFinancingOffer": "Erbjudande om företagsfinansiering",
  "capital.businessFinancingSummary": "Sammanfattning av företagsfinansiering",
  "capital.closed": "Stängt",
  "capital.couldNotContinueWithTheOffer": "Det gick inte att gå vidare med erbjudandet.",
  "capital.couldNotLoadFinancialOffers": "Det gick inte att läsa in finansiella erbjudanden.",
  "capital.dailyRepaymentRate": "Daglig återbetalningstakt",
  "capital.daysAndDaysLeft": "%{days} dagar (%{daysLeft} dagar kvar)",
  "capital.expectedRepaymentPeriod": "Förväntad återbetalningstid",
  "capital.failed": "Misslyckad",
  "capital.fees": "Avgifter",
  "capital.fullyRepaid": "Helt återbetalt",
  "capital.goToTermsAndConditions": "Gå till villkor",
  "capital.grantID": "Bidrags-id",
  "capital.howMuchMoneyDoYouNeed": "Hur mycket pengar behöver du?",
  "capital.inProgress": "Pågående",
  "capital.legalSubtitleAU": "Adyen Capital tillhandahålls av Adyen Australia Pty Limited.",
  "capital.legalSubtitleEU": "Lån utfärdas av Adyen N.V.",
  "capital.legalSubtitleGB": "Lån utfärdas av Adyen N.V. som representeras av dess London-filial.",
  "capital.legalSubtitleUS": "Lån utfärdas av Adyen N.V. San Francisco Branch och villkoras av kreditgodkännande.",
  "capital.maximumRepaymentPeriod": "Maximal återbetalningstid",
  "capital.minimumRepaymentToRepayTheFinancingOnTime": "Minsta återbetalning var %{days} dag för att återbetala finansieringen i tid",
  "capital.needSomeExtraMoney": "Behöver du lite extra pengar?",
  "capital.offerLegalNoticeDescriptionUS": "Om din ansökan om företagskredit avslås har du rätt att få en skriftlig förklaring av de specifika skälen till avslaget. För att få förklaringen ber vi dig kontakta Adyens Credit Support Team genom att skicka ett e-postmeddelande till %{email} inom 60 dagar från det datum då du informerades om vårt beslut. Vi kommer att skicka dig en skriftlig förklaring av skälen till avslaget inom 30 dagar efter att vi har tagit emot din begäran om förklaringen. %{break} Federal Equal Credit Opportunity Act förbjuder fordringsägare att diskriminera kreditsökande på grund av ras, hudfärg, religion, nationellt ursprung, kön, civilstånd, ålder (förutsatt att sökanden har rättslig kapacitet att ingå ett bindande avtal), huruvida hela eller delar av sökandens inkomst härrör från något offentligt biståndsprogram, eller på grund av att sökanden i god tro har utövat någon rätt enligt Consumer Credit Protection Act. Den federala myndighet som ansvarar för efterlevnaden av denna lag i förhållande till denna fordringsägare är Office of the Comptroller of the Currency (OCC), 400 7th Street, SW Washington, DC 20219, USA.",
  "capital.offerLegalNoticeTitleUS": "Fordringsägare: Adyen N.V. – San Francisco Branch %{break} 505 Brannan Street, San Francisco, CA 94107.",
  "capital.oneMonth": "1 månad",
  "capital.pending": "Väntande",
  "capital.primaryAccount": "Primärt konto",
  "capital.remaining": "Återstående",
  "capital.remainingAmount": "Återstående belopp",
  "capital.remainingFees": "Återstående avgifter",
  "capital.repaid": "Återbetalt",
  "capital.repaidAmount": "Återbetalat belopp",
  "capital.repaidFees": "Återbetalda avgifter",
  "capital.repaymentBalanceInfo": "Nuvarande återstående belopp, inklusive avgifter, är %{amount}",
  "capital.repaymentThreshold": "Tröskelvärde för återbetalning",
  "capital.requestedFunds": "Ansökta medel",
  "capital.requestFunds": "Ansök om pengar",
  "capital.requesting": "Begäran görs",
  "capital.reviewOffer": "Granska erbjudande",
  "capital.revoked": "Återkallat",
  "capital.seeNewOffer": "Se nytt erbjudande",
  "capital.seeOptions": "Se alternativ",
  "capital.sendRepayment": "Skicka återbetalning",
  "capital.sendRepaymentNotice": "Det kan ta 2–3 arbetsdagar innan den extra banköverföringen för återbetalning av ditt lån syns på ditt lånekonto.",
  "capital.sendRepaymentSubtitle": "Överför pengar till det här bankkontot för att betala tillbaka en del av eller hela lånet.",
  "capital.signTermsAndConditionsToReceiveFunds": "Underteckna villkoren för att få dina pengar.",
  "capital.signTheTermsToReceiveYourFunds": "Underteckna villkoren för att få dina pengar",
  "capital.termEnds": "Villkorsperioden avslutas: ",
  "capital.thereIsNoPrimaryAccountConfigured": "Det finns inget primärt konto konfigurerat",
  "capital.thisOfferExpiresOn": "Detta erbjudande löper ut den %{date}.",
  "capital.totalFees": "Summa avgifter",
  "capital.totalRepaymentAmount": "Totalt återbetalningsbelopp",
  "capital.unsupportedRegionDescription": "Företagsfinansiering är inte tillgängligt i din region ännu, men undersök status genom att återkomma hit.",
  "capital.unsupportedRegionTitle": "Håll dig uppdaterad!",
  "capital.weCouldNotContinueWithTheOffer": "Det gick inte att gå vidare med erbjudandet.",
  "capital.weCouldNotContinueWithTheOfferContactSupportForHelp": "Det gick inte att gå vidare med erbjudandet. Kontakta support för hjälp.",
  "capital.weCouldNotLoadFinancialOffers": "Det gick inte att läsa in finansiella erbjudanden.",
  "capital.weCouldNotProcessThisRequestTryAgain": "Det gick inte att behandla denna begäran. Försök igen med ett nytt erbjudande.",
  "capital.weReceivedYourRequestAndWeAreWorkingOnItNowCheckBackSoon": "Vi har tagit emot din begäran och arbetar med den nu. Kom snart tillbaka för nästa steg.",
  "capital.writtenOff": "Avskriven",
  "capital.xDays": "%{days} dagar",
  "capital.xMonths": "%{months} månader",
  "capital.xPercent": "%{percentage} %",
  "capital.youAcceptedButThenReturnedTheseFunds": "Du accepterade men returnerade sedan pengarna",
  "capital.youAcceptedTheseFundsButDidNotRepayThem": "Du accepterade pengarna men betalade inte tillbaka dem",
  "capital.youAreRequestingFundingOf": "Du ansöker om följande medel",
  "capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part1": "Du är förhandskvalificerad för företagsfinansiering",
  "capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part2": " upp till %{amount}.",
  "capital.yourRequestedFundsWere": "Dina ansökta medel var: ",
  "capital.youShouldGetTheFundsWithinOneBusinessDay": "Du bör få pengarna inom ett arbetsdag",
  "capital.youWillNeedToRepayAMinimumOfXEveryXDaysToPayOffTheFunds": "Du måste betala tillbaka minst %{amount} var %{days} dag för att helt betala av pengarna senast %{date}.",
  "capital.youWillSoonQualifyForAFinancialOffer": "Du kommer snart att kvalificera dig för ett ekonomiskt erbjudande!",
  capture: p,
  category: f,
  chargeback: m,
  closeIconLabel: k,
  contactSupport: b,
  contactSupportForHelp: v,
  contactSupportForHelpAndShareErrorCode: h,
  copied: y,
  copy: T,
  correction: A,
  currency: D,
  date: F,
  dateRange: R,
  default: "Standard",
  description: P,
  dismiss: S,
  download: C,
  downloading: N,
  email: O,
  entityWasNotFound: B,
  entityWasNotFoundDetail: I,
  "error.pleaseTryAgainLater": "Försök igen senare.",
  "error.somethingWentWrongWithDownload": "Något gick fel med nedladdningen",
  "expandableCard.collapse": "Minimera",
  "expandableCard.expand": "Expandera",
  export: "Exportera",
  fee: x,
  file: w,
  "filter.date.since": "Sedan %{date}",
  "filter.date.until": "Till %{date}",
  filterBar: L,
  "filterPlaceholder.category": "Typ",
  "filterPlaceholder.currency": "Valuta",
  "filterPlaceholder.status": "Status",
  from: j,
  full: W,
  fundsCaptured: M,
  goBack: U,
  grantIssued: K,
  grantRepayment: E,
  hideContent: q,
  id: V,
  incompleteField: H,
  inProgress: Y,
  loading: G,
  max: _,
  min: z,
  mobile: X,
  netPayout: J,
  nextPayouts: Q,
  noData: Z,
  noNegativeNumbersAllowed: $,
  noPayoutsFound: ee,
  noReportsFound: te,
  noTransactionsFound: ae,
  other: ne,
  paginatedNavigation: re,
  "pagination.nextPage": "Nästa sida",
  "pagination.previousPage": "Föregående sida",
  "pagination.showing": "Visar",
  partial: ie,
  paymentId: oe,
  paymentMethod: le,
  payoutDetails: se,
  payoutsNotice: de,
  payoutsTitle: ce,
  Pending: ge,
  pleaseComeBackLater: ue,
  pleaseReachOutToSupportForAssistance: pe,
  "rangePreset.custom": "Anpassat",
  "rangePreset.last30Days": "Senaste 30 dagarna",
  "rangePreset.last7Days": "Senaste 7 dagarna",
  "rangePreset.lastMonth": "Förra månaden",
  "rangePreset.lastWeek": "Förra veckan",
  "rangePreset.thisMonth": "Den här månaden",
  "rangePreset.thisWeek": "Denna vecka",
  "rangePreset.yearToDate": "Hittills i år",
  reachOutToSupport: fe,
  referenceID: me,
  refresh: ke,
  refund: be,
  "refund.amountAlreadyRefunded": "Du har redan återbetalat %{amount}",
  "refund.amountFailed": "Återbetalningen av %{amount} misslyckades. Just nu går det inte att återbetala beloppet. Kontakta supporten.",
  "refund.amountInProgress": "Den delvisa återbetalningen av %{amount} behandlas.",
  "refund.fee": "Avgift",
  "refund.fullAmountFailed": "Det är inte möjligt att återbetala denna betalning. Kontakta supporten.",
  "refund.fullAmountRefunded": "Hela beloppet har återbetalats till kunden",
  "refund.goToPayment": "Gå till betalning",
  "refund.maximumRefundable": "Du kan bara återbetala högst %{amount}",
  "refund.onlyRefundable": "Du kan bara återbetala %{amount}",
  "refund.originalAmount": "Ursprungligt belopp",
  "refund.originalPayment": "Ursprunglig betalning",
  "refund.paymentPspReference": "Betalningens PSP-referens",
  "refund.pspReference": "PSP-referens",
  "refund.refundFee": "Återbetalningsavgift",
  "refund.refundPspReference": "Återbetalningens PSP-referens",
  "refund.returnToRefund": "Återgå till återbetalning",
  "refund.theRefundIsBeingProcessed": "Återbetalningen bearbetas.",
  refundAction: ve,
  refundActionErrorSubtitle: he,
  refundActionErrorTitle: ye,
  refundActionSuccessSubtitle: Te,
  refundActionSuccessTitle: Ae,
  refundAmount: De,
  "refundAmount.excess": "Du får inte överskrida det tillgängliga beloppet på %{amount}",
  "refundAmount.required": "Ange återbetalningsbelopp",
  "refunded.full": "Helt återbetalt",
  "refunded.partial": "Delvis återbetalt",
  refundNotice: Fe,
  refundPayment: Re,
  refundReason: Pe,
  "refundReason.duplicate": "Dubblett",
  "refundReason.fraudulent": "Bedräglig",
  "refundReason.issue_with_item_sold": "Problem med såld artikel",
  "refundReason.other": "Annat",
  "refundReason.requested_by_customer": "Begärt av kunden",
  refundReference: Se,
  "refundReference.placeholder": "Ange referensen här",
  remainingAmount: Ce,
  report: Ne,
  "reportsError.tooManyDownloads": "Det gick inte att ladda ner alla filer. Försök igen senare.",
  reportsNotice: Oe,
  reportsTitle: Be,
  "reportType.payout": "Utbetalning",
  reset: Ie,
  Reversed: xe,
  "select.filter.placeholder": "Platshållare",
  "select.noOptionsFound": "Inga alternativ matchar denna sökning",
  somethingWentWrong: we,
  somethingWentWrongTryRefreshingOrComeBackLater: Le,
  status: je,
  structuredList: We,
  subtractions: Me,
  sumOfSameDayPayouts: Ue,
  tabs: Ke,
  theErrorCodeIs: Ee,
  thereAreNoResults: qe,
  theRequestIsMissingRequiredFieldsOrContainsInvalidData: Ve,
  thereWasAnUnexpectedError: He,
  theSelectedBalanceAccountIsIncorrect: Ye,
  timezone: Ge,
  to: _e,
  "tooltip.ATM": "Pengar tas ut i en bankomat",
  "tooltip.Capital": "Pengar från ett inkommande lånebidrag eller en utgående låneåterbetalning",
  "tooltip.Chargeback": "Pengar returnerades till en kund efter en omtvistad transaktion",
  "tooltip.Correction": "Justeringar av dina medel, inklusive återföringar av transaktioner och korrigeringar av insättningar",
  "tooltip.Fee": "Transaktionskostnader och avgifter för betalningssätt",
  "tooltip.Other": "Transaktioner som inte tillhör en annan kategori, vanligtvis en justering",
  "tooltip.Payment": "Pengar som kommit in på ditt konto från en försäljningstransaktion",
  "tooltip.Refund": "Pengar som skickats tillbaka till en kund från en återbetald transaktion",
  "tooltip.totalIncoming": "Alla pengar som tagits emot på ditt konto baserat på de valda filtren",
  "tooltip.totalOutgoing": "Alla avgifter, återbetalningar, utbetalningar och andra avgifter baserade på de valda filtren",
  "tooltip.Transfer": "Pengar som flyttats mellan ditt konto och ett annat konto",
  totalIncoming: ze,
  totalOutgoing: Xe,
  toValueShouldBeGreaterThanTheFromValue: Je,
  transactionDetails: Qe,
  transactions: Ze,
  transactionsOverviewTitle: $e,
  transactionType: et,
  transfer: tt,
  tryDifferentSearchOrResetYourFiltersAndWeWillTryAgain: at,
  tryRefreshingThePageOrComeBackLater: nt,
  txAmount: rt,
  "txType.ATM": "ATM",
  "txType.Capital": "Capital",
  "txType.Chargeback": "Chargeback",
  "txType.Correction": "Korrektion",
  "txType.Fee": "Avgift",
  "txType.Other": "Annat",
  "txType.Payment": "Betalning",
  "txType.Refund": "Återbetalning",
  "txType.Transfer": "Överföring",
  type: it,
  value: ot,
  weCouldNotLoadThePayoutsOverview: lt,
  weCouldNotLoadTheReportsOverview: st,
  weCouldNotLoadTheTransactionsOverview: dt,
  weCouldNotLoadYourBalanceAccounts: ct,
  weCouldNotLoadYourPayouts: gt,
  weCouldNotLoadYourReports: ut,
  weCouldNotLoadYourTransactions: pt
};
export {
  u as Booked,
  ge as Pending,
  xe as Reversed,
  e as account,
  t as accountBalance,
  a as accountDescription,
  n as accountID,
  r as additions,
  i as adjustments,
  o as amount,
  l as and,
  s as apply,
  d as back,
  c as balanceAccount,
  g as balanceAccountId,
  p as capture,
  f as category,
  m as chargeback,
  k as closeIconLabel,
  b as contactSupport,
  v as contactSupportForHelp,
  h as contactSupportForHelpAndShareErrorCode,
  y as copied,
  T as copy,
  A as correction,
  D as currency,
  F as date,
  R as dateRange,
  ft as default,
  P as description,
  S as dismiss,
  C as download,
  N as downloading,
  O as email,
  B as entityWasNotFound,
  I as entityWasNotFoundDetail,
  x as fee,
  w as file,
  L as filterBar,
  j as from,
  W as full,
  M as fundsCaptured,
  U as goBack,
  K as grantIssued,
  E as grantRepayment,
  q as hideContent,
  V as id,
  Y as inProgress,
  H as incompleteField,
  G as loading,
  _ as max,
  z as min,
  X as mobile,
  J as netPayout,
  Q as nextPayouts,
  Z as noData,
  $ as noNegativeNumbersAllowed,
  ee as noPayoutsFound,
  te as noReportsFound,
  ae as noTransactionsFound,
  ne as other,
  re as paginatedNavigation,
  ie as partial,
  oe as paymentId,
  le as paymentMethod,
  se as payoutDetails,
  de as payoutsNotice,
  ce as payoutsTitle,
  ue as pleaseComeBackLater,
  pe as pleaseReachOutToSupportForAssistance,
  fe as reachOutToSupport,
  me as referenceID,
  ke as refresh,
  be as refund,
  ve as refundAction,
  he as refundActionErrorSubtitle,
  ye as refundActionErrorTitle,
  Te as refundActionSuccessSubtitle,
  Ae as refundActionSuccessTitle,
  De as refundAmount,
  Fe as refundNotice,
  Re as refundPayment,
  Pe as refundReason,
  Se as refundReference,
  Ce as remainingAmount,
  Ne as report,
  Oe as reportsNotice,
  Be as reportsTitle,
  Ie as reset,
  we as somethingWentWrong,
  Le as somethingWentWrongTryRefreshingOrComeBackLater,
  je as status,
  We as structuredList,
  Me as subtractions,
  Ue as sumOfSameDayPayouts,
  Ke as tabs,
  Ee as theErrorCodeIs,
  Ve as theRequestIsMissingRequiredFieldsOrContainsInvalidData,
  Ye as theSelectedBalanceAccountIsIncorrect,
  qe as thereAreNoResults,
  He as thereWasAnUnexpectedError,
  Ge as timezone,
  _e as to,
  Je as toValueShouldBeGreaterThanTheFromValue,
  ze as totalIncoming,
  Xe as totalOutgoing,
  Qe as transactionDetails,
  et as transactionType,
  Ze as transactions,
  $e as transactionsOverviewTitle,
  tt as transfer,
  at as tryDifferentSearchOrResetYourFiltersAndWeWillTryAgain,
  nt as tryRefreshingThePageOrComeBackLater,
  rt as txAmount,
  it as type,
  ot as value,
  lt as weCouldNotLoadThePayoutsOverview,
  st as weCouldNotLoadTheReportsOverview,
  dt as weCouldNotLoadTheTransactionsOverview,
  ct as weCouldNotLoadYourBalanceAccounts,
  gt as weCouldNotLoadYourPayouts,
  ut as weCouldNotLoadYourReports,
  pt as weCouldNotLoadYourTransactions
};
